import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, Spinner } from "reactstrap";


const DeleteModal = ({
  showDelete,
  setShowDelete,
  onDeleteClick,
  setSelectedIds,
  title = "areYouSure",
  description ,
  confirmBtnText = "yesDelete",
  loading = false,
}) => {
  const { t, i18n } = useTranslation();

  const handleCloase =()=> {
    setShowDelete(false);
    if (setSelectedIds) {
      setSelectedIds([]);
    }
  };
  return (
    <Modal isOpen={showDelete} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{t(title)}</h4>
            <p className="text-muted mx-4 mb-0">{t(description)}</p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={() => handleCloase()}
          >
            {t("Close")}
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger d-flex align-items-center"
            id="delete-record"
            onClick={onDeleteClick}
            disabled={loading}
          >
            {loading && (
              <Spinner
                style={{
                  height: "18px",
                  width: "18px",
                  marginRight: "10px",
                }}
              >
                {" "}
              </Spinner>
            )}
            {t(confirmBtnText)}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  showDelete: PropTypes.any,
};

export default DeleteModal;
